import { useDeviceLocationTracking } from '@lp/core/hooks/useDeviceLocationTracking';
import { TxCenterDetailsModal } from '@lp/features/modals/TxCenterDetailsModal/TxCenterDetailsModal';
import TabSection from '@features/components/CaseOverview/components/TabSection/TabSection';
import SectionCard from '@features/components/CaseOverview/components/SectionCard/SectionCard';
import { EtaSections } from '@features/components/CaseOverview/components/Eta/EtaSections';
import SectionRow from '@features/components/CaseOverview/components/SectionRow/SectionRow';
import { useDisclosure } from '@ds';
import { Case, ServiceType } from '@/api/apis/case';
import { EditCaseTxCenterModal } from '../components/EditCaseForms/EditCaseTxCenter/EditCaseTxCenterModal';
import { TXCenterSurgeonInfo } from './TXCenterSurgeonInfo';
import { TXCenterCoordinatorInfo } from './TXCenterCoordinatorInfo';
import { FacilityRows } from '../components/FacilityRows';
import { useTxCenterPermissions } from '../hooks/useTxCenterPermissions';
import { useTxCenterEta } from '../hooks/useTxCenterEta';

type TxCenterProps = {
  caseData: Case;
};

export const TxCenter = ({ caseData }: TxCenterProps) => {
  const { isOpen: isOpenTx, onOpen: onOpenTx, onClose: onCloseTx } = useDisclosure();
  const { disableEditing } = useTxCenterPermissions(caseData);
  const { displayEtaTypes, txEtaData, txCenterOREta } = useTxCenterEta(caseData);

  const { caseId, status, txCenterDetails, assignedCustomers, serviceType, logisticsReference } = caseData;

  const deviceTracking = useDeviceLocationTracking({ caseId, status, logisticsId: logisticsReference?.id });

  const coordinator = assignedCustomers?.CustomerCoordinators?.find((c) => c.isDefaultTxUser);
  const surgeon = assignedCustomers?.CustomerReceivingSurgeons?.find((c) => c.isDefaultTxUser);

  return (
    <TabSection onSectionEdit={disableEditing ? undefined : onOpenTx} title="TX Center Info">
      {isOpenTx && <EditCaseTxCenterModal isOpen={isOpenTx} onClose={onCloseTx} caseData={caseData} />}
      <SectionCard>
        <TxCenterDetailsModal txCenterId={txCenterDetails?.id}>
          <div className="cursor-pointer flex flex-col gap-5">
            <FacilityRows facilityDetails={txCenterDetails} label="TX Center" addressLabel="TX Center Address" />
          </div>
        </TxCenterDetailsModal>
        {serviceType !== ServiceType.DirectAcquisition && (
          <>
            <TXCenterSurgeonInfo surgeon={surgeon} />
            <TXCenterCoordinatorInfo txCenterId={txCenterDetails?.id} coordinator={coordinator} />
          </>
        )}
        <EtaSections
          displayEtaTypes={displayEtaTypes}
          txEtaData={txEtaData}
          txCenterOREta={txCenterOREta}
          deviceTracking={deviceTracking}
          SectionRowComponent={SectionRow}
        />
      </SectionCard>
    </TabSection>
  );
};
